<template>
	<div id="OrderColportajeModalComponent" class="orderColportajeModalComponent">
        <button class="btn-link" data-toggle="modal" data-target="#orderColportajeModalComponent" ref="btnShowOrderColportajeModalComponent" @click="showOrderColportajeModalComponent" v-show="false">Nuevo Pedido</button>
		<div class="modal fade" tabindex="-1" role="dialog" id="orderColportajeModalComponent" aria-labelledby="myLargeModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static">
			<div class="modal-dialog modal-xl">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Nuevo Pedido para Campaña {{teamName}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
                        <div style="margin-right:-10px; margin-top:10px">
                            <div class="row">
                                <div class="col-md-7">
                                    <div style="height: 500px; overflow: auto; margin-bottom:10px" class="border rounded">
                                        <table class="table table-sm">
                                            <thead>
                                                <tr>
                                                    <th class="text-center" width="36">#</th>
                                                    <th class="text-center">Articulo</th>
                                                    <th class="text-center" width="100">Cantidad</th>
                                                    <th class="text-center" width="100">Precio</th>
                                                    <th class="text-center" width="100">Total</th>
                                                    <th class="text-center" width="21"></th>
                                                </tr>
                                            </thead>
                                        </table>
                                        <div style="height: 405px; overflow: auto;">
                                            <table class="table table-sm">
                                                <tbody>
                                                    <tr v-for="(it, index) in item.order_products" :key="index">
                                                        <td class="text-center" width="36">{{ index + 1 }}</td>
                                                        <td :title="'Codigo: ' + it.product_id">{{ it.product }}</td>
                                                        <td class="text-right" width="100">
                                                            <input type="number" class="text-right width-50" id="quantity"
                                                                v-model="it.quantity"
                                                                @focus="it.quantityOld = it.quantity; $event.target.select()"
                                                                @blur="analyzeQuantity(it)"
                                                                v-on:keyup.enter="analyzeEnterOrderProductLocal(it)"/>
                                                        </td>
                                                        <td class="text-right" width="100">{{ methodFormatNumber(it.price) }}</td>
                                                        <td class="text-right" width="100">{{ methodFormatNumber(it.quantity * it.price) }}</td>
                                                        <td class="text-right" width="21">
                                                            <i class="far fa-trash-alt text-danger pointer" @click="deleteItemOrderProductLocal(it)"></i>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <table class="table table-sm" style="margin-bottom:0px">
                                            <tfoot>
                                                <tr>
                                                    <td class="text">Diezmo: {{ methodFormatNumber(diezmoOrderProducts) }}</td>
                                                    <td colspan="3" class="text-right" style="font-size: 24px;"><b>TOTAL:</b></td>
                                                    <td class="text-right" width="100" style="font-size: 24px;"><b>{{ methodFormatNumber(totalOrderProducts) }}</b></td>
                                                    <td width="21" style="font-size: 24px;"></td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                    <div class="border rounded bg-secondary" style="padding:10px; margin-bottom:3px">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="form-group row">
                                                    <label for="inputClientOrder" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Cargado a:</label>
                                                    <div class="col-sm-8">
                                                        <input-auto-complete-componenet
                                                            ref="inputAutoCompleteComponenetClient"
                                                            placeholder="Escriba el nombre de cliente"
                                                            _class="form-control form-control-sm"
                                                            :urlGet="'clients/getByUser'"
                                                            _id="inputClientOrder"
                                                            :vmodel="item.client_id"
                                                            :text="item.client"
                                                            @actionSelectItem="setClientLocal"></input-auto-complete-componenet>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label for="inputData" class="col-sm-4 col-form-label text-right" style="font-weight: normal" >Fecha:</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control form-control-sm" id="inputData" disabled="true">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class="form-group row">
                                                    <label for="inputSendToOrder" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Enviar a:</label>
                                                    <input-auto-complete-componenet
                                                            ref="inputAutoCompleteComponenetSendTo"
                                                            placeholder="Escriba a quien se envía"
                                                            _class="form-control form-control-sm"
                                                            :urlGet="'client/' + item.client_id + '/sendto'"
                                                            _id="inputSendToOrder"
                                                            :text="item.sendto[0].sendto"
                                                            :vmodel="item.sendto[0].client_sendto_id"
                                                            :disabled="item.client_id == 0"
                                                            @actionSelectItem="setSendtoLocal"></input-auto-complete-componenet>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group row">
                                                    <label for="inputPhone" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Telefono:</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control form-control-sm" id="inputPhone" v-model="item.sendto[0].phone" placeholder="Ej: 932165487">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group row">
                                                    <label for="inputPhone" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Rut:</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control form-control-sm" id="inputPhone" v-model="item.sendto[0].number_document" placeholder="Ej: 12345678-9">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group row">
                                                    <label for="inputPhone" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Telefono:</label>
                                                    <div class="col-sm-8">
                                                        <input type="text" class="form-control form-control-sm" id="inputPhone" v-model="item.sendto[0].email" placeholder="Ej: correoclientereceptor@mail.cl">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-7">
                                                <div class="form-group row">
                                                    <label for="inputAddress" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Dirección:</label>
                                                    <div class="col-sm-8">
                                                        <input-auto-complete-componenet
                                                            ref="inputAutoCompleteComponenetAddress"
                                                            placeholder="Escriba la dirección"
                                                            _class="form-control form-control-sm"
                                                            :urlGet="'client/' + item.client_id + '/address'"
                                                            _id="inputAddress"
                                                            :text="item.sendto[0].address"
                                                            :vmodel="item.sendto[0].address_id"
                                                            :disabled="item.client_id == 0"
                                                            @actionSelectItem="setAddresLocal"></input-auto-complete-componenet>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group row">
                                                    <label for="inputComuna" class="col-sm-4 col-form-label text-right" style="font-weight: normal">Comuna:</label>
                                                    <div class="col-sm-8">
                                                        <select class="form-control form-control-sm" id="inputComuna" v-model="item.sendto[0].comuna_id" :disabled="item.client_id == 0">
                                                            <option v-for="(it, ind) in listComunas" :key="ind" :value="it.id">{{ it.name }} ({{ it.region }})</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <label for="inputObservation" class="col-sm-2 col-form-label text-right" style="font-weight: normal">Observación:</label>
                                            <div class="col-sm-10">
                                                <textarea class="form-control" id="inputObservation" rows="2" v-model="item.order_observations[0].observation" :disabled="item.client_id == 0" style="font-size: 12px"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-5">
                                    <div class="card card-info">
                                        <div class="card-header" style="padding: 10px;">
                                            <div class="form-group row" style="margin:0px;">
                                                <h3 for="priceListsSelect" class="col-sm-5 col-form-label card-title">Lista de Precio: </h3>
                                                <div class="col-sm-7" v-if="listPriceListsClient.length != 1">
                                                    <select class="form-control form-control-sm" id="priceListsSelect" v-model="priceListsIdSelect" @change="getProductPriceListLocal" :disabled="listPriceListsClient.length == 0">
                                                        <option v-for="(it, index) in listPriceListsClient" :key="index" :value="it.id">{{ it.name}}</option>
                                                    </select>
                                                </div>
                                                <h3 class="col-sm-7 col-form-label card-title" v-else>{{ listPriceListsClient[0].name }}</h3>
                                            </div>
                                        </div>
                                        <!-- /.card-header -->
                                        <div class="card-body" style="padding: 5px 10px">
                                            <div class="input-group mb-3">
                                                <label v-show="1 == 0" for="searchProductList" ref="searchProductList"></label>
                                                <input type="text" class="form-control form-control-sm" placeholder="Ingrese producto a buscar" aria-label="Ingrese producto a buscar" aria-describedby="basic-addon2" id="searchProductList"
                                                    v-model="searchProductList"
                                                    v-on:keyup.enter="analyzeEnterSearchProductList()"
                                                    :disabled="listPriceListsClient.length == 0">
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary btn-sm" @click="quantity++" :disabled="listPriceListsClient.length == 0">x {{ quantity }}</button>
                                                    <button class="btn btn-outline-secondary btn-sm" type="button" :disabled="listPriceListsClient.length == 0" @click="analyzeEnterSearchProductList()"><i class="fas fa-search"></i></button>
                                                    <span v-show="1 == 0" class="btn btn-outline-secondary btn-sm" type="button" @click="clearListPriceListsClient" ref="spanClearListPriceListsClient"><i class="fas fa-broom"></i></span>
                                                </div>
                                            </div>
                                            <div style="height: 600px; overflow-y: auto;">
                                                <div class="alert alert-secondary" role="alert" style="padding: 5px 10px; margin: 5px 4px"
                                                    v-for="(it, index) in listProductsPriceList" :key="index">
                                                    <h5 class="fas fa-cart-plus float-right pointer margin-top5 text-primary" title="Agregar al pedido" @click="addProductToOrderProducLocal(it)"></h5>
                                                    <p>
                                                        <div class="font-weight-bold">{{ it.product }}</div>
                                                        <div style="margin-top: -5px;" v-for="(i, ind) in it.attacheds" :key="ind">
                                                            <i><small>+ {{ i.product }}</small></i>
                                                        </div>
                                                        <div v-if="it.attacheds.length == 0" style="height: 10px;"></div>
                                                    </p>
                                                    <div class="row">
                                                        <div class="col-md-5">
                                                            <small>Código {{ it.product_id }}</small>
                                                        </div>
                                                        <div class="col-md-7 text-right">
                                                            <h6>${{ methodFormatNumber(totalItemProduct(it)) }}</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary" @click="saveOrderComponent" :disabled="disableButtonSaveOrder">Guardar</button>
						<button type="button" class="btn btn-secondary" data-dismiss="modal" ref="btnCloseOrderModalComponent" @click="btnCloseOrderModalComponent">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import mixin from '@/mixins'
    import errors from '@/mixins/errors.js'
    import axiosAction from '@/mixins/axiosAction.js'
    import client from '@/mixins/clients/'
    import comuna from '@/mixins/generals/comuna.js'
    import productPriceList from '@/mixins/products/productPriceList.js'
    import order from '@/mixins/orders'

    import InputAutoCompleteComponent from '@/components/InputAutoCompleteComponent.vue'

    export default {
		name: 'OrderColportajeModalComponent',
        mixins: [mixin, errors, axiosAction, comuna, client, productPriceList, order],
        props: ['teamId', 'teamName'],
		data () {
			return {
                priceListsIdSelect: 0,
                quantity: 1,
                searchProductList: '',
                tax: 0.19,
                closing: false,
                item : {
                    exists: 0,
                    id: 0,
                    client_id: 0,
                    client: '',
                    client_address_client_sendto_id: 0,
                    team_id: this.teamId,
                    sendto: [{
                        exists: 0,
                        id: 0,
                        client_id: 0,
                        address_id: 0,
                        street: '',
                        comuna_id: 0,
                        client_sendto_id: 0,
                        sendto: '',
                        number_document: '',
                        email: '',
                        phone: '',
                        created_at: '',
                        updated_at: ''
                    }],
                    order_observations: [{
                        id: 0,
                        order_id: 0,
                        observation: '',
                        created: '',
                        user_id: 0,
                        user: '',
                        img: ''
                    }],
                    tithe: 0,
                    created_at: '',
                    updated_at: '',
                    order_products: [],
                    order_trackings_shipping: []
                },
			}
		},
		computed: {
            totalOrderProducts() {
                let total = this.item.order_products.reduce(function(a, b) { 
                                let c = b.quantity * b.price
                                return a + c
                            }, 0);
                this.item.total = total
                return total.toFixed(0)
            },
            diezmoOrderProducts() {
                let total = this.item.order_products.reduce((a, b) => {
                                let c = 0
                                if(this.calculateTitheProduct(b.product_id))
                                    c = ((b.quantity * b.price) / 1.19) * 0.1
                                return a + c
                            }, 0);
                this.item.tithe = Math.round(total)
                return total.toFixed(0)
            },
            disableButtonSaveOrder() {
                if(this.item.client_id < 1 )
                    return true
                if(this.item.sendto[0].sendto.trim().length < 3)
                    return true
                if(this.item.sendto[0].phone.trim().length < 9)
                    return true
                if(this.item.sendto[0].street.trim().length < 5)
                    return true
                if(this.item.sendto[0].comuna_id < 1 )
                    return true
                if(this.item.order_products.length == 0)
                    return true
                return false
            },
		},
		methods: {
            addProductToOrderProducLocal(item) {
                this.addOrderProductLocal(item)
                Object.values(item.attacheds).forEach(it => {
                    this.addOrderProductLocal(it)
                })
                this.quantity = 1
                setTimeout(()=>{ this.$refs.searchProductList.click() }, 100)
            },
            addOrderProductLocal(item) {
                let index = this.item.order_products.map((el) => parseInt(el.product_id)).indexOf(parseInt(item.product_id))
                if(index > -1) {
                    this.item.order_products[index].quantity = parseInt(this.item.order_products[index].quantity) + parseInt(this.quantity)
                } else {
                    this.item.order_products.push({
                        id: this.item.order_products.length + 1,
                        product_id: item.product_id,
                        product: item.product,
                        quantity: this.quantity,
                        price: item.price,
                        price_list_id: item.price_list_id,
                        tax: this.tax
                    })
                }
                return
            },
            analyzeEnterOrderProductLocal(item) {
                setTimeout(()=>{ this.$refs.searchProductList.click() }, 100)
            },
            analyzeEnterSearchProductList() {
                if(!isNaN(this.searchProductList) && this.searchProductList.trim() != '' && this.searchProductList.length < 8 && this.searchProductList > 0) {
                    this.quantity = this.searchProductList
                    this.searchProductList = ''
                } else if (!isNaN(this.searchProductList) && this.searchProductList.trim() != '' && this.searchProductList.length == 13) {
                    alert('buscar como codigo')
                } else if(this.searchProductList.substring(0, 1).toUpperCase() == 'H' && !isNaN(this.searchProductList.substring(1, this.searchProductList.trim().length))) {
                    alert('Buscar por codigo ' + this.searchProductList.substring(1, this.searchProductList.trim().length))
                } else {
                    this.getProductPriceList(this.priceListsIdSelect ,this.searchProductList)
                }
            },
            analyzeQuantity(item) {
                item.quantity = (item.quantity.trim() == '' || isNaN(item.quantity)) ? item.quantityOld : item.quantity
            },
            btnCloseOrderModalComponent() {
                this.clearItem()
                this.closing = true
                this.quantity = 1
                this.listPriceListsClient = []
                this.listProductsPriceList = []
                this.$refs.inputAutoCompleteComponenetClient.$refs.buttonClearInputComplete.click()
                this.$refs.inputAutoCompleteComponenetSendTo.$refs.buttonClearInputComplete.click()
                this.$refs.inputAutoCompleteComponenetAddress.$refs.buttonClearInputComplete.click()
            },
            calculateTitheProduct(productId) {
                let list = this.listProductsPriceListNotTithe.filter((i) => {
                        return (parseInt(i.product_id) == parseInt(productId) && parseInt(i.price_list_id) == parseInt(this.priceListsIdSelect))
                    })
                return (list.length == 0)
            },
            clearItem() {
                this.item.exists = 0
                this.item.id = 0
                this.item.client_id = 0
                this.item.client = ''
                this.item.client_address_id = 0 
                this.item.team_id = 0 
                this.item.sendto[0].exists = 0
                this.item.sendto[0].id = 0
                this.item.sendto[0].client_id = 0
                this.item.sendto[0].address_id = 0
                this.item.sendto[0].street = ''
                this.item.sendto[0].comuna_id = 0
                this.item.sendto[0].client_sendto_id = 0
                this.item.sendto[0].sendto = ''
                this.item.sendto[0].number_document = ''
                this.item.sendto[0].email = ''
                this.item.sendto[0].phone = ''
                this.item.sendto[0].created_at = ''
                this.item.sendto[0].updated_at = ''
                this.item.created_at = ''
                this.item.updated_at = ''
                this.item.order_observations[0].id = 0
                this.item.order_observations[0].order_id = 0
                this.item.order_observations[0].observation = ''
                this.item.order_observations[0].created = ''
                this.item.order_observations[0].user_id = 0
                this.item.order_observations[0].user = ''
                this.item.order_observations[0].img = ''
                this.item.order_products = []
                this.item.order_trackings_shipping = []
            },
            clearListPriceListsClient() {
                this.closing = false
                this.quantity = 1
                this.listPriceListsClient = []
                this.listProductsPriceList = []
                this.$refs.inputAutoCompleteComponenetSendTo.$refs.buttonClearInputComplete.click()
                this.$refs.inputAutoCompleteComponenetAddress.$refs.buttonClearInputComplete.click()
            },
            deleteItemOrderProductLocal(item) {
                let index = this.item.order_products.map((el) => parseInt(el.product_id)).indexOf(parseInt(item.product_id))
                let orderProducts = this.item.order_products.splice(index,1)
            },
            getAllPriceListsClientResultLocal(response) {
                if(response.data.data.length > 0) {
                    this.priceListsIdSelect = response.data.data[0].id
                    this.getProductPriceList(response.data.data[0].id)
                    this.getProductPriceListNotTithe(this.priceListsIdSelect)
                }
            },
            getAllComunasResultLocal(){},
            getProductPriceListLocal() {
                this.getProductPriceList(this.priceListsIdSelect ,this.searchProductList)
                this.getProductPriceListNotTithe(this.priceListsIdSelect)
            },
            getProductPriceListResultLocal(response) {
            },
            initComponentLocal() {
                setTimeout(() => {
                    this.getAllComunas()
                }, 100)
            },
            resultAxiosLocal(responseLocal, response) {
                this.$emit('hideLockScreen')
                switch(responseLocal) {
                    case 'getAllComunasResult': this.getAllComunasResult(response); break;
                    case 'getAllPriceListsClientResult': this.getAllPriceListsClientResult(response); break;
                    case 'getProductPriceListResult': this.getProductPriceListResult(response); break;
                    case 'getProductPriceListNotTitheResult': this.getProductPriceListNotTitheResult(response); break;
                    case 'getAllComunasResult': this.getAllComunasResult(response); break;
                    case 'saveOrderResult': this.saveOrderResult(response); break;
                    default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
                }
            },
            saveOrderComponent() {
                this.saveOrder(this.item)
            },
            saveOrderResultLocal(response) {
                if(response.data.success === true) {
                    this.$emit('saveOrderComponent', response.data.data)
                    this.$refs.btnCloseOrderModalComponent.click()
                } else {

                }
            },
            showOrderColportajeModalComponent() {
            },
            setAddresLocal(item) {
                this.item.sendto[0].address_id = item.id
                this.item.sendto[0].street = item.text
                if(item.id > 0) {
                this.item.sendto[0].comuna_id = item.comuna_id
                    this.item.sendto[0].comuna = item.comuna
                } else {
                this.item.sendto[0].comuna_id = 0
                    this.item.sendto[0].comuna = 0
                }
            },
            setClientLocal(item, key) {
                if(key == 'Enter') {
                    if(item.id == 0 && !this.closing) {
                        this.$snotify.info('Debes selecciconar un cliente de la lista', 'Sin Seleccion')
                    } else if(item.id > 0) {
                        this.item.client_id = item.id
                        this.item.client = item.client
                        this.item.sendto[0].client_id = item.id
                        this.getAllPriceListsClient(item.id)
                    }
                } else if(this.item.client_id != item.id){
                    this.priceListsIdSelect = 0
                    this.item.sendto[0].sendto = ''
                    setTimeout(() => {
                        this.$refs.inputAutoCompleteComponenetSendTo.$refs.buttonClearInputComplete.click()
                        this.$refs.inputAutoCompleteComponenetAddress.$refs.buttonClearInputComplete.click()
                    }, 10)
                    this.listPriceListsClient = []
                    this.listProductsPriceList = []
                    this.item.client_id = item.id
                    this.item.client = ''
                    this.item.sendto[0].client_id = item.id
                    this.item.sendto[0].client_sendto_id = 0
                    this.item.sendto[0].phone = ''
                    this.item.sendto[0].comuna_id = 0
                    this.item.sendto[0].comuna = ''
                    this.priceListsIdSelect = 0
                    this.listPriceListsClient = []
                    this.listProductsPriceList = []
                }
            },
            setSendtoLocal(item) {
                this.item.sendto[0].client_sendto_id = item.id
                this.item.sendto[0].sendto = item.text
                this.item.sendto[0].phone = item.phone
                this.item.sendto[0].number_document = item.number_document
                this.item.sendto[0].email = item.email
                if(item.id == 0) {
                    this.item.sendto[0].client_sendto_id = 0
                    this.item.sendto[0].sendto = item.text
                    this.item.sendto[0].phone = ''
                    this.item.sendto[0].number_document = ''
                    this.item.sendto[0].email = ''
                }
            },
            totalItemProduct(item) {
                let price = parseInt(item.price)
                Object.values(item.attacheds).forEach(it => {
                    price = parseInt(it.price) + parseInt(price)
                })
                return price
            }
		},
        components: {
            'input-auto-complete-componenet': InputAutoCompleteComponent,
        },
        mounted () {
	    	this.initComponentLocal()
	    }
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.label-normal {
    font-weight:normal;
}
</style>
